import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { ChatBubbleAttachmentsProps } from "./types";

/**
 * Slot for attachment thumbnails. ChatBubble owns layout only — the consumer
 * passes whatever thumbnail / lightbox-trigger components it needs.
 */
export const ChatBubbleAttachments = ({
  children,
  className,
  testID,
}: ChatBubbleAttachmentsProps) => (
  <Box
    className={cn("gap-spacing-xs mt-spacing-xs flex flex-row flex-wrap", className)}
    {...platformProps({ testID, slot: "chat-bubble-attachments" })}
  >
    {children}
  </Box>
);

ChatBubbleAttachments.displayName = "ChatBubble.Attachments";
